// 用户操作相关API接口地址
const UserApi = {
    Login: "/login",    // 用户登录
};

//  机构管理 相关API接口地址
const OrganApi = {
    List: '/tatinfo/list',    // 获取机构管理列表
    Add: '/tatinfo/add',        // 添加机构管理
    Update: '/tatinfo/edit',     // 修改机构管理信息
    Prohibit: '/tatinfo/udpStatus', // 机构z状态修改
    SimpleNames: '/tatinfo/getSimpleNames', // 机构简称列表
    Detail: '/tatinfo/detail', // 机构详情
    Abbrs: '/tatinfo/getAbbrs', // 机构缩写列表
    GetMems: '/tatinfo/getMems', // 机构会员列表
    privateMemList: '/t-private-mem-info/list', // 机构会员列表
    privateMemudpStatus: '/t-private-mem-info/udpStatus', // 机构会员列表
    privateMemMerchantDel: '/t-private-mem-merchant/delete', // 机构会员列表
    privateMemMerchantList: '/t-private-mem-merchant/list', // 机构会员列表
    OrganUserInsert: '/meminfo/easyaddByManage', // 机构会员列表
    GetTatAndApps: '/tatinfo/getTatAndApps', // 机构会员列表
    SelectOne: '/tatinfo/selectOne', // 会员管理查询机构返佣类型
    BlackAdd: '/blacklist/add', // 黑名单-手动拉黑
    BlackList: '/blacklist/list', // 黑名单-按条件搜索黑名单列表
    BlackOut: '/blacklist/out', // 黑名单-移除黑名单
    BlackUpdate: '/blacklist/update', // 黑名单-修改拉黑记录
    RebateLogInfo: '/rebateLogInfo/list', // 返利
    RebateLogInfoAdd: '/rebateLogInfo/add',// 返利充值

    AccountSuperviseList: '/memAcct/list',//账户管理
    AccountSuperviseListNew: '/activity/admin-activity-sn/list',
    AccountTopList: '/merInfo/mer-acq-sim/list',
    AccountJiaoyi: '/pospMer/mer-trade-detail/list',
    AccountSuperviseEdit: '/memAcct/edit',

    MerchantInfoList: '/merchantinfo/t-merchant-info/list',//商户详情
    MerchantInfoHB: '/merchantinfo/t-merchant-info/issuedMachine',
    MerchantInfoEdit: '/merchantinfo/t-merchant-info/updateById',
    MerchantInfoZx: '/merchantinfo/t-merchant-info/cancelMerchantInfo',
    MerchantInfoUp: '/merchantinfo/t-merchant-info/updateIndex',
    MerchantInfoStatus: '/merchantinfo/t-merchant-info/editMemInfoFlag',
    CopyMerchantInfoManageFeilv: '/merchantinfo/t-merchant-terminal-fee/list',
    newGengxin: '/merchantinfo/t-merchant-info/selectFy',
    CopyMerchantInfoManageList: '/merchant-terminal/list',
    CopyMerchantInfoManageInsert: '/merchant-terminal/addTerminal',
    CopyMerchantInfoManageEdit: '/merchant-terminal/updateTerminalActiveSubType',
    CopyMerchantInfoManageDel: '/merchant-terminal/del',

    MemberupgradeList: '/memLevelManage/mem-level-manage/list',//代理商等级
    MemberupgradeEdit: '/memLevelManage/mem-level-manage/edit',
    MemberupgradeInsert: '/memLevelManage/mem-level-manage/add',
    MemberupgradeDel: '/memLevelManage/mem-level-manage/delete',

    GetMemUps: '/memUp/getMemUps',//代理商升级查询

    PartnerLevelManageList: '/partnerLevelSetting/detail',//合伙人升级配置
    PartnerLevelManageUpdate: '/partnerLevelSetting/edit',
    PartnerLookInfoList: '/sharedtl/t-share-dtl/list',
    PartnerLevelInfoList: '/partnerdtl/t-partner-dtl/list',

    UpgradeassessmentList: '/accesssetting/t-access-setting/detail',//考核配置
    UpgradeassessmentSave: '/accesssetting/t-access-setting/edit',

    AgentPerformanceList: '/agentPerformance/list',
    AgentPerformanceHj: '/agentPerformance/total',
    AgentPerformanceDetailsList: '/shareplan/t-performance-dtl/list',

    IdentityManageList: '/identity/t-identity-setting/detail',
    IdentityManageUpdate: '/identity/t-identity-setting/edit',

    MerchantEvaluationList: '/evaluate/t-agent-evaluate-info/list',//商户评价
    MerchantEvaluationAdd: '/evaluate/t-agent-evaluate-info/add',

    CloudFlashPaymentList: '/ysf/t-ysf-merchant-info/list',//云闪付商户
};

//  机构管理——提现管理 相关API接口地址
const OrganCashApi = {
    List: '/tatwithdraw/getAll',
    Add: '/tatwithdraw/add',
    Update: '/tatwithdraw/edit',
    Detail: '/tatwithdraw/detail',
    ClickSwitch: '/tatwithdraw/cutAisle',
    DpStatus: '/tatwithdraw/udpStatus',
    IsExist: '/tatwithdraw/isExist',

    Delete: '/tatwithdraw/delete',
    CardTatAwardList: '/cardTatAward/list',
    CardTatAwardAdd: '/cardTatAward/add',
    CardTatAwardEdit: '/cardTatAward/edit',
    CardTatAwardDetail: '/cardTatAward/detail',
    CardTatAwardCheck: '/cardTatAward/checkExist',
    CardTatAwardDel: '/cardTatAward/delete',
    TatCardTestList: '/tatCardTest/list',
    TatCardTestAdd: '/tatCardTest/add',
    TatCardTestEdit: '/tatCardTest/edit',
    TatCardTestDetail: '/tatCardTest/detail',
    TatCardTestCheck: '/tatCardTest/checkExist',
    TatCardTestDel: '/tatCardTest/delete',
    // 新增启用禁用
    addAllDel: '/tatwithdraw/udpStatusAll'
};

//  机构管理——机构短信 相关API接口地址
const OrganNoteApi = {
    List: '/tatsms/list',    // 获取机构管理列表
    Add: '/tatsms/add',        // 添加机构管理
    Update: '/tatsms/edit',     // 修改机构管理信息
    DpStatus: '/tatsms/udpStatus', // 机构z状态修改
    Detail: '/tatsms/detail', // 机构详情
    IsExist: '/tatsms/isExist', // 机构详情
    Delete: '/tatsms/delete', // 机构详情
};

//  机构管理——应用位置 相关API接口地址
const OrganAppApi = {
    List: '/tatappposition/list',
    Add: '/tatappposition/add',
    Update: '/tatappposition/edit',
    Delete: '/tatappposition/delete',
    Detail: '/tatappposition/detail',
};

//  机构管理——机构认证 相关API接口地址
const OrganAuthApi = {
    List: '/tatrauth/list',    // 获取机构管理列表
    Add: '/tatrauth/add',        // 添加机构管理
    Update: '/tatrauth/edit',     // 修改机构管理信息
    DpStatus: '/tatrauth/udpStatus', // 机构z状态修改
    Detail: '/tatrauth/detail', // 机构详情
    IsExist: '/tatrauth/isExist', // 机构详情
    Delete: '/tatrauth/delete', // 机构详情
    GetShortNames: '/chnrauth/getShortNames', // 机构详情
    IsExistTatAndTradingType: '/tatrauth/isExistTatAndTradingType', // 机构详情
};

//  机构管理——支付费率 相关API接口地址
const OrganRateApi = {
    Add: '/tatfee/add',       //支付费率添加
    List: '/tatfee/list',       //支付费率列表
    Update: '/tatfee/edit',
    DpStatus: '/tatfee/udpStatus',
    Detail: '/tatfee/detail',
    Delete: '/tatfee/delete',
    CardOrderList: '/cardOrder/list',
    CardCloseOrder: '/cardOrder/closeOrder',
};

//  通道管理 相关API接口地址
const ChannelApi = {
    TatTaxJumpLineList: '/tatTaxJumpLine/list',
    TatTaxJumpLineAdd: '/tatTaxJumpLine/add',
    TatTaxJumpLineEdit: '/tatTaxJumpLine/edit',
    TatTaxJumpLineDel: '/tatTaxJumpLine/delete',

};

//  通道管理——支付费率 相关API接口地址
const ChannelRateApi = {
    GetByChn: '/chnfee/getByChn', // 线路名称列表
};

//  通道管理——短信管理 相关API接口地址

//  通道管理——支付宝管理 相关API接口地址

//  通道管理——认证管理 相关API接口地址

//  通道管理——提现管理 相关API接口地址
const ChannelCashApi = {
    GetAllNames: '/chnwithdraw/getAllNames',
    TatPayRateList: '/tatPayRate/list',
    TatPayRateAdd: '/tatPayRate/add',
    TatPayRateEdit: '/tatPayRate/edit',
    TatPayRateIsExist: '/tatPayRate/isExist',
    TatPayRateDel: '/tatPayRate/delete',
    TatRefundList: '/tatRefund/list',
    GetInfoByOrderId: '/tatRefundInfo/getInfoByOrderId',
    TatRefundInfoList: '/tatRefundInfo/getList',
    TatRefundInfoRefund: '/tatRefundInfo/refund',
    TatRefundInfoForceRefund: '/tatRefundInfo/forceRefund',
    UpdatePaySt: '/rongbao/fastpay/updatePaySt',
};

//  系统管理——字典管理 相关API接口地址
const SystemDicApi = {
    List: '/sysdict/list',
    Add: '/sysdict/add',
    Detail: '/sysdict/detail',
    CheckUnique: '/sysdict/checkUnique', //  唯一键查询
    Update: '/sysdict/edit',
    DpStatus: '/sysdict/udpStatus',
    ByType: '/sysdict/getByType',        //根据类型查询

    JHLIst: '/statistics/commonutil/countTMachines',        //团队激活机具查询
    HLFLIst: '/statistics/commonutil/countTHlfInfoDtl',        //团队欢乐返查询
    WTXLIst: '/statistics/commonutil/count3KOrder',        //网体下3000查询
};

//  系统管理——配置中心 相关API接口地址
const SystemPropApi = {
    List: '/tSysProperties/list',
    Add: '/tSysProperties/add',
    Detail: '/tSysProperties/detail',
    Update: '/tSysProperties/edit',
    Exist: '/tSysProperties/exist',
    meltList: '/melt/t-melt-config/list',
    meltEdit: '/melt/t-melt-config/edit',
};

//  系统管理——推送管理 相关API接口地址

//  权限管理——用户管理 相关API接口地址
const PowerUserApi = {
    List: '/user/select',
    Add: '/user/add',
    Update: '/user/update',
    Delete: '/user/delete',
    ModifyPW: '/user/modifyPW',
    SelectOne: '/user/selectOne',
    selectPerms: '/user/selectPerms',
};

//  权限管理——角色管理 相关API接口地址
const PowerRoleApi = {
    List: '/role/select',
    Add: '/role/add',
    Update: '/role/update',
    Delete: '/role/delete',
    SelectOne: '/role/selectOne',
    SelectPerms: '/role/selectPerms',
    SelectMenu: '/role/selectMenu',
};

//  权限管理——权限管理 相关API接口地址
const PowerInfoApi = {
    List: '/perm/select',
    Add: '/perm/add',
    Update: '/perm/update',
    Delete: '/perm/delete',
    SelectOne: '/perm/selectOne',
    Upload: '/picture/upload',
};

//  代理商管理——代理商管理 相关API接口地址


// 交易管理 相关API接口地址
const TransactionApi = {
    MemInfoParentInfoList: '/memInfoParentInfo/list',
    FindAllByIdCard: '/merInfo/findAllByIdCard',       // 进件
    MerInfoToggle: '/merInfo/toggle',       // 进件
    MerInfoRefresh: '/merInfo/refresh',       // 进件
    GetProfitDtl: '/profit/getDetail',          // 获取收益详情
    GetRauths: '/auth/listByUser',          // 实名认证查询
    GetCardCCs: '/card/findByConditions',          // 信用卡查询
    GetPlanDtl: '/repay/getDetail',          // 获取计划详情
    GetRepayPlanById: '/plan/calculateTranInfo',          // 获取计划详情
    SelectBalence: '/chnMemBalance/queryBalance',          // 查询余额
    MemCardDelDtl: '/memCardDelDtl/list',          // 删卡记录
    OcrAuthGetList: '/ocr/getListByUser',          // 人证列表
    OcrDisable: '/ocr/disable',          // 人证列表
    OcrAuthGetDetail: '/ocrAuth/getDetail',          // 人证列表
    HbWeizhInfo: '/hbWeizhInfo/list',          //
    HbWeizhInfoAgain: '/hbWeizhInfo/again',          //
    UpdatePeopleInfo: '/tatPublicPlatoonPeople/updatePeopleInfo',          //
    UpdatePreLicensing: '/tatPublicPlatoonPeople/updatePreLicensing',          //

    ZhifuGetRauths: '/agreementAdmin/query/agreement',          // 认证协议
    GetStatus: '/agreementAdmin/anew/signature',            //认证协议操作

    TransactionmanageList: '/qpayInfo/qpay-info/list',  //交易查询相关接口
    TransactionmanageList2: '/qpayInfo/qpay-info/list2',  //交易查询相关接口
    TransactionmanageHeji: '/qpayInfo/qpay-info/transAmountCount',
    TransactionmanageHeji2: '/qpayInfo/qpay-info/transAmountCount2',
    settleAccounts: '/qpayInfo/qpay-info/settleAccounts',
    settleAccounts2: '/qpayInfo/qpay-info/settleAccounts2',
    settleAccountsOnly: '/qpayInfo/qpay-info/settleAccountsOnly',
    settleAccountsOnly2: '/qpayInfo/qpay-info/settleAccountsOnly2',

    AgentShareList: '/fin/memacct-dtl/list',  //代理商分润相关接口
    AgentShareAdd: '/integral/t-integral-dtl/myToYourShoppAcctSuper',

    PointsDetailsList: '/integral/t-integral-dtl/list',  //积分明细相关接口
    PointsDetailsHeji: '/integral/t-integral-dtl/sumNumber',
    PointsDetailsTiaoz: '/integral/t-integral-dtl/adjust',

    AppPointsDetailsList: '/integral/t-merchant-integral-dtl/list',  //商户App积分明细相关接口
    XJAppPointsDetailsList: '/integral/t-merchant-acct-dtl/list',
    merchantinfoAdjust: '/merchantinfo/t-merchant-info/adjust',
    AppPointsNewOdetojoyManageList: '/xhls/config/list',  //鼓励金
    AppPointsNewOdetojoyManageEdit: '/xhls/config/edit',
    AppPointsNewOdetojoyManageStatus: '/xhls/config/udpStatus',

    AppPointsNewOdetojoyInfoList: '/xhls/merchant-info/list',
    AppPointsNewOdetojoyInfoUp: '/xhls/merchant-info/upMerchantInfo',
    AppPointsNewOdetojoyInfoUpTwo: '/merchant-info-two/upMerchantInfo',
    AppPointsNewOdetojoyInfoEdit: '/xhls/merchant-info/update',
    AppPointsNewOdetojoyInfoLookList: '/xhls/merchant-info-bak/list',
    AppPointsNewOdetojoyInfoLookUpdate: '/xhls/merchant-info-bak/updateById',

    YsPosAppPointsNewOdetojoyManageList: '/xhls/big-config/list',  //银盛鼓励金
    YsPosAppPointsNewOdetojoyManageEdit: '/xhls/big-config/edit',
    YsPosAppPointsNewOdetojoyManageStatus: '/xhls/big-config/udpStatus',

    YsPosAppPointsNewOdetojoyInfoList: '/xhls/big-merchant-info/list',
    YsPosAppPointsNewOdetojoyInfoEdit: '/xhls/big-merchant-info/update',
    YsPosAppPointsNewOdetojoyInfoLookList: '/xhls/big-merchant-info-bak/list',

    ZXList: '/xhls/jx_config/list',  //专项鼓励金
    ZXEdit: '/xhls/jx_config/edit',
    ZXStatus: '/xhls/jx_config/udpStatus',

    ZXInfoList: '/xhls/jx_merchant-info/list',
    MoveGlj: '/xhls/jx_merchant-info/moveGlj',
    ZXInfoLookList: '/xhls/jx_merchant-info-bak/list',
    ZXInfoLookUpdate: '/xhls/jx_merchant-info-bak/updateById',

    TwoAppPointsNewOdetojoyManageList: '/config-two/list',  //鼓励金2.0
    lklAppPointsNewOdetojoyManageList: '/config-lkl/list',  //鼓励金2.0
    TwoAppPointsNewOdetojoyManageEdit: '/config-two/edit',
    lklAppPointsNewOdetojoyManageEdit: '/config-lkl/edit',
    TwoAppPointsNewOdetojoyManageStatus: '/config-two/udpStatus',
    lklAppPointsNewOdetojoyManageStatus: '/config-lkl/udpStatus',

    ThreeAppPointsNewOdetojoyManageList: '/config-three/list',  //鼓励金2.0
    ThreeAppPointsNewOdetojoyManageAdd: '/config-three/add',
    ThreeAppPointsNewOdetojoyManageEdit: '/config-three/edit',
    ThreeAppPointsNewOdetojoyManageStatus: '/config-three/udpStatus',

    TwoAppPointsNewOdetojoyInfoList: '/merchant-info-two/list',
    lklAppPointsNewOdetojoyInfoList: '/merchant-info-lkl/list',
    TwoAppPointsNewOdetojoyInfoEdit: '/merchant-info-two/update',
    lklAppPointsNewOdetojoyInfoEdit: '/merchant-info-lkl/update',
    TwoAppPointsNewOdetojoyInfoLookList: '/merchant-info-bak-two/list',
    lklAppPointsNewOdetojoyInfoLookList: '/merchant-info-bak-lkl/list',
    TwoAppPointsNewOdetojoyInfoLookUpdate: '/merchant-info-bak-two/updateById',
    lklAppPointsNewOdetojoyInfoLookUpdate: '/merchant-info-bak-lkl/updateById',

    ThreeAppPointsNewOdetojoyInfoList: '/merchant-info-three/list',
    ThreeAppPointsNewOdetojoyInfoEdit: '/merchant-info-three/update',
    ThreeAppPointsNewOdetojoyInfoLookList: '/merchant-info-bak-three/list',
    ThreeAppPointsNewOdetojoyInfoLookUpdate: '/merchant-info-bak-three/updateById',

    TwoZXList: '/jx_config_tow/list',  //专项鼓励金2.0
    TwoZXEdit: '/jx_config_tow/edit',
    TwoZXStatus: '/jx_config_tow/udpStatus',

    ThreeZXList: '/jx_config_three/list',  //专项鼓励金2.0
    ThreeZXEdit: '/jx_config_three/edit',
    ThreeZXStatus: '/jx_config_three/udpStatus',

    TwoMoveGlj: '/jx_merchant-info_tow/moveGlj',
    TwoZXInfoList: '/jx_merchant-info_tow/list',
    TwoZXInfoLookList: '/jx_merchant-info-bak_tow/list',
    TwoZXInfoLookUpdate: '/jx_merchant-info-bak_tow/updateById',

    ThreeMoveGlj: '/jx_merchant-info_three/moveGlj',
    ThreeZXInfoList: '/jx_merchant-info_three/list',
    ThreeZXInfoLookList: '/jx_merchant-info-bak_three/list',
    ThreeZXInfoLookUpdate: '/jx_merchant-info-bak_three/updateById',
    ThreezxgljList: '/zxglj/xhls-config-three-profit/list',
    ThreezxgljEdit: '/zxglj/xhls-config-three-profit/edit',
    payTypeList: '//xhls/jx-paytype/list',


    MerchantGrowthFundDetailsList: '/returnstrategy/t-return-strategy-dtl/list',

    AppPointsagentOperationsList: '/xhls/merchant-log/list',

    AppPointsTransactionManageList: '/returnstrategy/t-merchant-return-strategy/list',
    AppPointsTransactionManageEdit: '/returnstrategy/t-merchant-return-strategy/edit',
    AppPointsTransactionManageInsert: '/returnstrategy/t-merchant-return-strategy/add',
    AppPointsTransactionManageStatus: '/returnstrategy/t-merchant-return-strategy/udpStatus',
    AppPointsTransactionManageDel: '/returnstrategy/t-merchant-return-strategy/delete',

    HappyReturnManageList: '/hlf/t-hlf-config/list',  //商欢乐返配置相关接口
    HappyReturnManageEdit: '/hlf/t-hlf-config/edit',
    HappyReturnManageStatus: '/hlf/t-hlf-config/udpStatus',

    TwoHappyReturnManageList: '/hlf/t-hlf-config-two/list',  //2.0商欢乐返配置相关接口
    TwoHappyReturnManageEdit: '/hlf/t-hlf-config-two/edit',
    TwoHappyReturnManageAdd: '/hlf/t-hlf-config-two/add',
    TwoHappyReturnManageStatus: '/hlf/t-hlf-config-two/udpStatus',
    threehappyreturnmanageAdd: '/hlf/t-hlf-config-three/add',  //2.0商欢乐返配置相关接口
    ThreeHappyReturnManageList: '/hlf/t-hlf-config-three/list',  //2.0商欢乐返配置相关接口
    ThreeHappyReturnManageEdit: '/hlf/t-hlf-config-three/edit',
    ThreeHappyReturnManageStatus: '/hlf/t-hlf-config-three/udpStatus',

    DetailedHappyReturnList: '/hlf/t-hlf-info-dtl/list',

    TwoDetailedHappyReturnList: '/hlf/t-hlf-info-dtl-task/list',  //欢乐返2考核
    ThreeDetailedHappyReturnList: '/hlf/t-hlf-info-dtl-task-three/list',  //欢乐返2考核

    ActiveReentryManageList: '/hyf/t-hyf-config/list',  //活跃返返配置相关接口
    ActiveReentryManageEdit: '/hyf/t-hyf-config/edit',
    ActiveReentryManageStatus: '/hyf/t-hyf-config/udpStatus',

    ActiveReentryInfoList: '/hyf/t-hyf-info-dtl/list',

    TeamRewardsManageList: '/reward/t-reward-config/list',  //团队奖励配置
    TeamRewardsManageEdit: '/reward/t-reward-config/edit',
    TeamRewardsManageInsert: '/reward/t-reward-config/add',
    TeamRewardsManageDel: '/reward/t-reward-config/delete',

    TeamComplianceList: '/reward/t-reward-dtl/list',

    TeamExcellenceManageList: '/teamTransactionConfig/list',//团队卓越奖励配置
    TeamExcellenceManageEdit: '/teamTransactionConfig/edit',
    TeamExcellenceManageInsert: '/teamTransactionConfig/add',
    TeamExcellenceManageDel: '/teamTransactionConfig/delete',

    MerchantActivationManageList: '/merchantRewardConfig/detail',  //商户激活奖励配置
    MerchantActivationManageUpdate: '/merchantRewardConfig/edit',

    MerchantactivationExamineList: '/merchantRewardProcess/list',  //商户激活奖励审核
    MerchantactivationExamineSh: '/merchantRewardProcess/udpStatus',
    MerchantactivationExamineTj: '/merchantRewardProcess/executeReward',

    //商户活动 优惠卷相关接口
    //优惠券管理
    CouponManageList: '/coupon/t-coupon/list',
    CouponManageEdit: '/coupon/t-coupon/edit',
    CouponManageInsert: '/coupon/t-coupon/add',
    CouponManageStatus: '/coupon/t-coupon/udpStatus',
    CouponManageDel: '/coupon/t-coupon/delete',
    KycpAll: '/machines/t-machines-type/list',

    //优惠劵组管理
    GetRealName: '/merchantinfo/t-merchant-info/getMerchant',
    GetRealNamePrivate: '/t-private-mem-info/detail',
    CouponListall: '/coupon/t-coupon/listAll',
    CouponGroupManageDetail: '/coupon/t-coupon-group/detail',
    CouponGroupManageList: '/coupon/t-coupon-group/list',
    CouponGroupManageEdit: '/coupon/t-coupon-group/edit',
    CouponGroupManageInsert: '/coupon/t-coupon-group/add',
    CouponGroupManageDel: '/coupon/t-coupon-group/delete',
    CouponGroupManageFaFang: '/coupon/t-coupon-group/send',
    CouponGroupupdateById: '/coupon/t-coupon-merchant/updateById',

    //商户优惠卷查询
    CouponMerchantSelectList: '/coupon/t-coupon-merchant/list',
    CouponMerchantSelectStatus: '/coupon/t-coupon-merchant/statusList',

    //优惠券转赠
    CouponInfoList: '/coupon/t-coupon-transfer-dtl/list',

    //商户签到配置
    AppPointsSignList: '/qdmerchant/t-qd-merchant-config/list',
    AppPointsSignEdit: '/qdmerchant/t-qd-merchant-config/edit',
    AppPointsSignInsert: '/qdmerchant/t-qd-merchant-config/add',
    AppPointsSignDel: '/qdmerchant/t-qd-merchant-config/delete',
    AppPointsSignInfoList: '/qdmerchant/t-qd-merchant-info/list',

    LKLExamineList: '/lkl/t-lkl-examine/list',
    LKLDepositList: '/lkl/t-lkl-deposit/list',
    LKLDepositDtlList: '/lkl/t-lkl-deposit-dtl/list',
    ZxgljProfitList: '/zxglj/xhls-config-profit/list',
    ZxgljProfitEdit: '/zxglj/xhls-config-profit/edit',
    ZxgljProfitInfo: '/zxglj/xhls-config-profit-info/list',
    addOrUpdateByManage: '/xhls/jx_merchant-info/addOrUpdateByManage',
     //=========================新增商户交易量
     tradeList: '/statistics/machines-transaction/list',
     addTrade: '/statistics/machines-transaction/addDay'
};

// 财务管理 相关API接口地址
const FinanceApi = {
    OfflinePay: '/memLevelUp/offlinePay',
    // GetRealNameByPhone: '/fin/getRealNameByPhone',
    GetRealNameByPhone: '/memInfo/getRealNameByPhone',
    GetRealNameByPhones: '/fin/getRealNameByPhones',
    GetNamePhoneNumber: '/fin/getRealNameAndMoneyByPhone',
    GetMerNo: '/merchantinfo/t-merchant-info/getMerchant',
    GetAdjusts: '/fin/getAdjusts',
    Adjust: '/fin/adjust',
    GetTatAssets: '/fin/getTatAssets',
    GetOutComeDtl: '/fin/getOutAccDtl',
    GetAdminAccDtl: '/fin/getAdminAccDtl',
    GetTatAccDtl: '/fin/tatacct-dtl/list',
    SelectFinTatacctDtl: '/finTatacctDtl/selectFinTatacctDtl',
    GetMemAccDtl: '/fin/getMemAccDtl',
    GetMemRewardAccDtl: '/fin/getMemRewardAccDtl',
    GetRecharges: '/fin/getRecharges',
    SaveRecharge: '/fin/saveRecharge',
    GetMemAccts: '/fin/getMemAccts',
    GetMemUps: '/fin/getMemUps',
    GetMemUpDtl: '/fin/getMemUpDtl',
    GetWithdraws: '/withdrawrecord/list',
    Frozen: '/fin/frozen',
    ApplyWithDraw: '/withdraw/applyWithDraw',
    AddTatAccountInfo: '/withdraw/addTatAccountInfo',
    GetAcctInfo: '/withdraw/getAcctInfo',
    SelectTempAcct: '/tatacct/selectTempAcct',
    CloseTempAcct: '/tatacct/closeTempAcct',
    DtlList: '/acctCloseDtl/dtlList',
    ShareWithdrawalList: '/shareWithdrawal/list',  // 财务提现
    ShareWithdrawalAdd: '/shareWithdrawal/add',  // 财务提现
    ShareWithdrawalBalanceQuery: '/shareWithdrawal/balanceQuery',  // 财务提现
    TatTaxLogAdd: '/tatTaxLog/count',
    TatTaxLog: '/tatTaxLog/statistics',
    TatTaxLogList: '/tatTaxLog/list',
    TatTaxMemList: '/tatTaxMem/list',
    TatTaxMemAdd: '/tatTaxMem/add',
    TatTaxMemcheckOnly: '/tatTaxMem/checkOnly',
    TatTaxMemDel: '/tatTaxMem/delete',
    TatTaxMemEdit: '/tatTaxMem/edit',
    TatTaxList: '/tatTax/list',
    TatTaxAdd: '/tatTax/add',
    TatTaxEdit: '/tatTax/edit',
    CheckOnly: '/tatTax/checkOnly',
    TatGeneralizationDtlList: '/tatGeneralizationDtl/list',
    TatGeneralizationDtlAwardSum: '/tatGeneralizationDtl/awardSum',
    TatTaxMemParameterList: '/tatTaxMemParameter/list',
    TatTaxMemParameterDel: '/tatTaxMemParameter/delete',
    TatTaxMemParameterAdd: '/tatTaxMemParameter/add',
    TatTaxMemParameterEdit: '/tatTaxMemParameter/edit',
    TatTaxMemStatistics: '/tatTaxMemLog/statistics',
    MemUpSecond: '/memUpSecond/list',
    GetMemAccDtlCountOperationAmt: '/fin/getMemAccDtlCountOperationAmt',    // 会员账户明细
    SumTatAccDtl: '/fin/tatacct-dtl/sumTatAccDtl',    // 合计
    SumMemAccDtl:'/fin/sumMemAccDtl', //会员账户明细合计
    GetMoney: '/fin/sumAdminAccDtl',

    ReceivedetailTiaoz: '/fin/tatacct-dtl/adjust',

    BonusPlanList:'/shareplan/t-share-plan/list',   //分红计划
    BonusPlanSh:'/shareplan/t-share-plan/check',
    BonusPlanPlSh:'/shareplan/t-share-plan/checkBatch',
    BonusPlanEdit:'/shareplan/t-share-plan/edit',
    BonusPlanFhjs:'/shareplan/t-share-plan/calculate',
    BonusPlanHj:'/shareplan/t-share-plan/totalAmt',
    BonusPlanDel:'/shareplan/t-share-plan/delete',
    BusiType: '/shareplan/t-share-plan/selectBusiType',

    TransferAccountsShList:'/tMoveMemacctDtl/list',  //转账审核
    TransferAccountsShSh:'/tMoveMemacctDtl/updateStatus',
    // 解除绑定
    deleteBind: '/merInfo/mer-tid-info/delete',
    lirunList: '/fin/tatacct-fee-dtl/list',
    lirunheji: '/fin/tatacct-fee-dtl/sumTatAccDtl'
};
// APP管理 相关API接口地址
const APPApi = {
    TatTatSourceMaterialList: '/tatTatSourceMaterial/list',
    TatTatSourceMaterialAdd: '/tatTatSourceMaterial/add',
    TatTatSourceMaterialEdit: '/tatTatSourceMaterial/edit',
    TatTatSourceMaterialDel: '/tatTatSourceMaterial/delete',
    TatTatSourceMaterialUdp: '/tatTatSourceMaterial/udpStatus',
    TatTatSourceMaterialType: '/tatTatSourceMaterial/getType',

    OperationVideoList: '/tatVariousLink/list',    //操作视频
    OperationVideoAdd: '/tatVariousLink/add',
    OperationVideoEdit: '/tatVariousLink/edit',
    OperationVideoDetail: '/tatVariousLink/detail',
    OperationVideoUdp: '/tatVariousLink/udpStatus',
    OperationVideoDel: '/tatVariousLink/delete',

    TatActivityMsg: '/tatActivityMsg/list',         // 公告
    TatActivityMsgDel: '/tatActivityMsg/delete',
    TatActivityMsgUdp: '/tatActivityMsg/udpStatus',
    TatActivityMsgAdd: '/tatActivityMsg/add',
    TatActivityMsgUpd: '/tatActivityMsg/update',

    HelpCenterList: '/help/t-help-centre/list',     // 帮助中心
    HelpCenterInsert: '/help/t-help-centre/add',
    HelpCenterEdit: '/help/t-help-centre/edit',
    HelpCenterDel: '/help/t-help-centre/delete',
    HelpCenterStatus: '/help/t-help-centre/udpStatus',


    List: '/tatApp/list',
    Add: '/tatApp/add',
    Edit: '/tatApp/edit',
    Delete: '/tatApp/delete',
    Detail: '/tatApp/detail',
    Upload: '/tatApp/upload',
    LoadApp: '/tatApp/loadApp',
    DetailList: '/tatApp/detailList',
    SysMsgList: '/sysMsg/list',         // 系统消息管理列表
    SysMsgCreate: '/sysMsg/create',         //
    SysMsgDelete: '/sysMsg/delete',         //
    SysMsgUpdate: '/sysMsg/update',         //
    SysMsgEnable: '/sysMsg/enable',         //
    GetVersionNum: '/tatApp/getVersionNum',
    SendList: '/tatsmssend/list',       //短信发送列表
    GetMemLevel: '/tatsmssend/getMemLevel',       //短信发送列表
    Sendsms: '/tatsmssend/sendsms',       //短信发送列表
    GetStatisCount: '/smssenddetail/getStatisCount',       //短信发送列表
    GetList: '/smssenddetail/list',       //短信发送列表
    TatMessageSettingAdd: '/tatMessageSetting/add',
    TatMessageSettingEdit: '/tatMessageSetting/edit',
    TatMessageSettingList: '/tatMessageSetting/list',
    TatMessageSettingDel: '/tatMessageSetting/delete',

    CustomconfigurationList: '/chnInfoConfig/chn-info-config/list',
    CustomconfigurationEdit: '/chnInfoConfig/chn-info-config/edit',
    CustomconfigurationInsert: '/chnInfoConfig/chn-info-config/add',
    CustomconfigurationDel: '/chnInfoConfig/chn-info-config/delete',
    BankNameYz: '/chnInfoConfig/chn-info-config/check',
    Status: '/chnInfoConfig/chn-info-config/updateStatus',

    BannerList:'/tatPayManageFather/list',
    BannerInsert:'/tatPayManageFather/add',
    BannerEdit:'/tatPayManageFather/edit',
    BannerDel:'/tatPayManageFather/delete',
    BannerStatus: '/tatPayManageFather/udpStatus',

    RBannerList:'/tatPayManage/list',
    RBannerInsert:'/tatPayManage/add',
    RBannerEdit:'/tatPayManage/edit',
    RBannerDel:'/tatPayManage/delete',
    RBannerStatus: '/tatPayManage/udpStatus',

    RoulettelList:'/dialLottery/list',   //轮盘抽奖
    RoulettelAdd:'/dialLottery/insert',
    RoulettelEdit:'/dialLottery/edit',
    RoulettelDel:'/dialLottery/delete',
    RoulettelStatus:'/dialLottery/update/status',

    RoulettelListFalse:'/dialLottery_false/list',   //轮盘抽奖
    RoulettelAddFalse:'/dialLottery_false/insert',
    RoulettelEditFalse:'/dialLottery_false/edit',
    RoulettelDelFalse:'/dialLottery_false/delete',
    RoulettelStatusFalse:'/dialLottery_false/update/status',

    ConfigList:'/dialLotteryCommodity/list',
    ConfigAdd:'/dialLotteryCommodity/insert',
    ConfigEdit:'/dialLotteryCommodity/edit',
    ConfigDel:'/dialLotteryCommodity/delete',

    ConfigListFalse:'/dialLotteryCommodity_false/list',
    ConfigAddFalse:'/dialLotteryCommodity_false/insert',
    ConfigEditFalse:'/dialLotteryCommodity_false/edit',
    ConfigDelFalse:'/dialLotteryCommodity_false/delete',


    UserLucklist:'/thjLotteryList/listPageWeb', //抽奖明细
    UserLuckadd:'/thjLotteryList/add',
    UserLuckedit:'/thjLotteryList/edit',
    UserLuckdel:'/thjLotteryList/delete',
    UserLuck: '/dialLotteryCommodity/getListByPondId',
    UserLotteryMovie: '/dialLottery/getList',

    StyleDisplayList:'/shineShow/list', //风采展示
    StyleDisplayEdit:'/shineShow/edit',
    StyleDisplayInsert:'/shineShow/add',
    StyleDisplayDel:'/shineShow/delete',
    StyleDisplayStatus: '/shineShow/udpStatus',

    RankIngManageUpdate:'/rankGame/edit', //排行榜管理相关接口
    RankIngManageList:'/rankGame/detail',

    MonthlyListList: '/rankgame/t-month-rank/list', //月榜查询

    WeekList: '/rankgame/t-week-rank/list', //周榜查询

    WeekNum: '/rankgame/t-week-rank/weekList',
    IntegralSource: '/rankGameCommon/integralSource',
    IntegralType: '/rankGameCommon/integralType',

    IntegrallistList: '/rankgame/t-rank-integral-dtl/list', //积分明细查询

    RewardlistList: '/rankgame/t-rank-award-dtl/list', //奖励明细查询
    RewardlistSH: '/rankgame/t-rank-award-dtl/check',

    NewRankIngManageUpdate:'/rankGame/edit', //新排行榜管理相关接口
    NewRankIngManageList:'/rankGame/list',
    NewRankIngManageStatus:'/rankGame/updateStatus',
    NewRankIngManageDel:'/rankGame/delete',
    NewRankIngManagegetType:'/rankGame/getType',
    NewRankIngManageDetail:'/rankGame/detail',

    NewMonthlyListList: '/rank/list', //月榜查询
    NewMonthlyListEdit: '/rank/edit', //月榜查询

    NewIntegrallistList: '/rankgame/t-rank-integral-dtl/list', //积分明细查询

    NewRewardlistList: '/rankgame/t-rank-award-dtl/list', //奖励明细查询
    NewRewardlistSH: '/rankgame/t-rank-award-dtl/check',

    MerchantLevelManageList: '/merchantUp/t-merchant-up-config/list',// 商户等级管理
    MerchantLevelManageEdit: '/merchantUp/t-merchant-up-config/edit',

    MerchantUpgradeInfoList: '/merchantUp/t-merchant-up-dtl/list',// 商户升级明细
};

// 增值业务 相关API接口地址

// 统计管理 相关API接口地址
const StatisticsApi = {
    selectByMemId: '/memacct/mem-acct-team-month/selectByMemId',        //团队交易量统计
    TeamTransactionList: '/memacct/mem-acct-ext/countMemAcctTeam',        //团队交易量统计
    TeamMonthTransactionList: '/memacct/mem-acct-team-month/countMemAcctTeam',        //团队交易量统计
    ShopTransactionTj: '/goods/order/tranSum',        //商城交易统计
    ShopVolumetjList: '/statistics/machines-transaction/list',        //商户交易量统计
    AgentVolumetjList: '/memacct/mem-acct-ext/list',        //代理商交易业绩统计
    ShopActivationLookList: '/statistics/machines-transaction/listPageByApp',        //商户激活奖励查询
    RevenueStatisticsList: '/fin/memacct-dtl/myGroupCountByWeb',        //收益统计
    EcPieList: '/statistics/sex/list',        //饼图
    EcLineChartList: '/statistics/birthday/list',        //折线
    EcAgeLineChartList: '/statistics/age/list',        //折线

    MerchantEcPieList: '/statistics/sex/list',        //饼图
    MerchantEcLineChartList: '/statistics/birthday/list',        //折线
    MerchantEcAgeLineChartList: '/statistics/age/list',        //折线

    Getdaily: '/statistics/getdaily',        //日统计
    ExportByBank: '/statis/exportByBank',        //银行导出
    GetStatisByAgent: '/statis/getStatisByAgent',        //代理统计
    Gmvtop: '/statis/gmvtop10',        //top10
    TranCountTOP: '/statis/tranCountTOP10',        //top10
    MemCountTOP: '/statis/memCountTOP10',        //top10
    TranCountCake: '/statis/tranCountCake',        //图形统计
    StatisQpayInfoQry: '/quickTran/staticsByConditions',        //
    StatisTatAssets: '/statistics/tatAssets',        // 机构账户查询的合计
    StatisWithdraws: '/statistics/withdraws',          //
    StatisGetAdjusts: '/statistics/getAdjusts',
    StatisGetMemAccts: '/statistics/getMemAccts',

    StatisGetUserStatis: '/statistics/getUserStatis',
    StatisGetChnStatis: '/statistics/getChnStatis',
    GetStatisByChnPaln: '/statis/getStatisRepayPlanDtlByChn',
    CountMdbFinTatacctDtl: '/finTatacctDtl/countMdbFinTatacctDtl',
    GetWithdrawalList:'/withdrawrecord/sumWithdrawAmout'
};

// 会员管理——会员管理 相关API接口地址
const MemberManApi = {
    Select: '/meminfo/select',   // 会员查询
    SelectOne: '/meminfo/selectOneByTatId',   // 会员详情
    UpdateParent: '/meminfo/updateParentId',   // 变更上级
    UpdateMemStatus: '/meminfo/updateMemStatus',   // 修改用户状态
    UpdateMemLevel: '/memLevelUp/memLvlUpRebate',   // 修改用户等级
    UnionFounder: '/meminfo/unionFounder',               // 联创
    UnionBill: '/meminfo/updateSmsFlag',               // 账单短信提醒
    UnionBillStatus: '/meminfo/updateAssessFlag',               // 考核状态
    SelectAllParents: '/meminfo/selectAllParents',               // 联创

    SelectCard: '/card/listAll',   // 卡片信息
    GetLogList: '/card/getLogList',
    PrivateGetLogList: '/t-private-mem-card/list',

    ChongZhi: '/meminfo/authReset',

    PosJiJuStatus: '/meminfo/editMemInfoFlag', //机具划拨开关
    StudioSwitch: '/meminfo/studioSwitch', //工作室
    editMemInfoFlag: '/t-private-mem-info/editMemInfoFlag', //个人

    UpdateProtectTime: '/meminfo/updateProtectTime', //保护期变更
    UpspecialDealer: '/meminfo/specialDealer', //特约代理商
    UpDealer: '/meminfo/dealer', //经销商
    PLGulijin: '/meminfo/editMemInfoFlagForBatch', //鼓励金团队批量

    AgentGift: '/gift/t-agent-gift/updateAgentGift', //礼包调级

    getMemInfoByUserId: '/t-private-mem-info/getMemInfoByUserId',
};

// 会员管理——会员升级管理 相关API接口地址
const MemberLevelApi = {
    RebateType: '/memlevelmanage/modifyRebateType',      //  修改机构返佣类型
    Select: '/memlevelmanage/select',
    Add: '/memlevelmanage/add',
    Delete: '/memlevelmanage/delete',
    SelectOne: '/memlevelmanage/selectOne',
    UpdateMemRateLevelChnFee: '/memratemanage/updateMemRateLevelChnFee',
    Update: '/memlevelmanage/update',
    ListNoPage: '/memLevelManage2d/listNoPage',
    MemLvlUp: '/memLevelManage2d/memLvlUp',
    AccountList: '/meminfo/getDMemInfo',
    AccountAdjustmentList: '/memacct/selectOneByTatId',
    AccountAdjustmentEdit: '/memacct/updateByUid',
};
// 会员管理——会员通道费率管理 相关API接口地址
const MemberChannelRateApi = {
    Select: '/memchnfee/select',
    Add: '/memchnfee/add',
    Delete: '/memchnfee/delete',
    SelectOne: '/memchnfee/selectOne',
    Update: '/memchnfee/update',
    GetChn: '/memchnfee/getChn',
};
// 支付管理--融宝

const RongBaoApi = {
    RegistList: '/rongbao/regist/list',
    BindList: '/rongbao/bind/list',
};

// 会员管理——会员升级费率管理 相关API接口地址
const MemberLevelRateApi = {
    SelectOne: '/memratemanage/selectOne',
    Add: '/memratemanage/add',
    Update: '/memratemanage/update',
    List: '/memratemanage/selectMemRateLevelChnFee',     //  会员费率管理查询
};

//办卡记录查询
const MemApplyInfoApi = {
    Detail: '/memApplyCardInfo/detail'
};

//机构办卡分润结算
const TatBankProfitApi = {
    List: '/tatProfitCheck/list',
    Add: '/tatProfitCheck/create',
    ComputeProfit: '/tatProfitCheck/computeProfit',
    Check: '/tatProfitCheck/check',
    Detail: '/tatProfitCheck/detail',
};

//机构办卡费率管理
const TatBankChnApi = {
    List: '/tatBankChn/list',
    Add: '/tatBankChn/create',
    Update: '/tatBankChn/update',
    Detail: '/tatBankChn/detail',
    Delete: '/tatBankChn/delete',
    Enable: '/tatBankChn/enable',
    Exist: '/tatBankChn/exist',
    GetBankInfo: '/tatBankChn/getBankInfo',
};

//办卡佣金设置管理

//办卡通道管理

//办卡通道管理
const EmptyApi = {
    GetChaseListDetail: '/helpchasemoneyextend/getChaseListPage',
    HelpAdd: '/helpchasemoneyextend/add',
};


// 营销管理

const MarketApi = {
    TatFakeProfitList: '/tatFakeProfit/list',
    TatFakeProfitAdd: '/tatFakeProfit/add',
    TatFakeProfitIsExist: '/tatFakeProfit/isExist',
    TatIndexDataUpdate: '/tatIndexData/update',
    TatIndexDataDetail: '/tatIndexData/detail',
    TatPublicPlatoonAdd: '/tatPublicPlatoon/add',
    TatPublicPlatoonEdit: '/tatPublicPlatoon/edit',
    TatPublicPlatoonUdp: '/tatPublicPlatoon/udpStatus',
    TatPublicPlatoonDel: '/tatPublicPlatoon/delete',
    TatPublicPlatoonList: '/tatPublicPlatoon/list',
    DetailForLineName: '/tatPublicPlatoon/detailForLineName',
    TatPublicPlatoonPeople: '/tatPublicPlatoonPeople/list',
    TatPublicPreLicensing: '/tatPublicPreLicensing/list',
    PublicPreListByPage: '/publicPre/listByPage',
    LicenReissue: '/tatPublicPreLicensing/reissue',
    SumMoney: '/tatPublicPreLicensing/sumMoney',
    MemLevelPublicPlatoonList: '/memLevelPublicPlatoon/list',
    MemLevelPublicPlatoonPeople: '/memLevelPublicPlatoonPeople/list',
    MemLevelPublicPlatoonLicensing: '/memLevelPublicPlatoonLicensing/list',
    MemLevelPublicPlatoonEdit: '/memLevelPublicPlatoon/edit',
    LevelPublicPeople:'/memLevelPublicPlatoonPeople/addPeople',

    TwoPublicPlatoonList: '/tatPublicPlatoonPeopleSuper/list',
    DandelionDotsortList: '/tatPublicPlatoonPeopleSuper/countListNotPageByWeb',

    MemberselecttwoList: '/meminfo/getMemInfoByMemlevel',
}


// 商城积分

const MallApi = {
    MemIntegralInfo: '/memIntegralInfo/mem-integral-info/detail',
    TatIntegralCardSetting: '/tatIntegralCardSetting/list',
    ChangeExpiredDate: '/memIntegralInfo/mem-integral-info/changeExpiredDate',
    StoreGoodsListAll: '/storeGoods/listAll',
    SmsList: '/smsWarning/list',
    SmsEdit: '/smsWarning/edit',
    SmsInsert: '/smsWarning/insert',
    SmsDelete: '/smsWarning/delete',
    SmsTypes:'/smsWarning/dict',
    ShoppingName: '/goodsDict/couponTypes',
    TatGoodsAdd: '/tatGoods/t-store-tat-goods/add',         //原商城
    TatGoodsDel: '/tatGoods/t-store-tat-goods/delete',
    TatGoodsEdit: '/tatGoods/t-store-tat-goods/edit',
    TatGoodsList: '/tatGoods/t-store-tat-goods/list',
    TatGoodsUdpStatus: '/tatGoods/t-store-tat-goods/udpStatus',

    PublicPlatoonGoodsAdd: '/tatGoodGp/add',             //公排商城
    PublicPlatoonGoodsDel: '/tatGoodGp/delete',
    PublicPlatoonGoodsEdit: '/tatGoodGp/edit',
    PublicPlatoonGoodsList: '/tatGoodGp/list',
    PublicPlatoonGoodsUdpStatus: '/tatGoodGp/udpStatus',

    GetBusinessType: '/memIntegralDtl/mem-integral-dtl/getBusinessType',

    WithdrawalReviewList: '/dflhwithdrawapply/list',
    WithdrawalReviewListDg: '/mer/withdraw/corporate/listH',
    WithdrawalReviewCheck: '/dflhwithdrawapply/checkApply',
    WithdrawalReviewCheckNew: '/dflhwithdrawapplytat/checkApply',
    WithdrawalReviewCheckNewDG: '/mer/withdraw/corporate/checkApply',
    ConnectWithdrawalReviewList: '/dflhwithdrawapply/list',
    ConnectWithdrawalReviewCheck: '/dflhwithdrawapply/checkApply',

    OfflinePaymentReviewList: '/memLevelManage2d/offline/list',
    OfflinePaymentReviewToExamine: '/memLevelManage2d/offline/check',

    OfflineQRCodeList: '/offlineQr/list',
    OfflineQRCodeEdit: '/offlineQr/edit',
    OfflineQRCodeInsert: '/offlineQr/add',
    OfflineQRCodeDel: '/offlineQr/delete',
    OfflineQRCodeStatus: '/offlineQr/enable',

    SumMoney: '/dflhwithdrawapply/myCount',
    TdMoney: '/dflhwithdrawapply/v2BackedOrderInfos',

    AgentshareHj: '/fin/memacct-dtl/myCountByWeb',
};

// 商城积分

const TatMemRewardsApi = {
    TatMemRewardsAdd: '/tatMemRewards/tat-mem-rewards/add',
    TatMemRewardsDetail: '/tatMemRewards/tat-mem-rewards/detail',
    TatMemRewardsRuleAdd: '/tatMemRewardsRule/add',
    TatMemRewardsRuleDetail: '/tatMemRewardsRule/detail',
    TatMemRewardsRuleEdit: '/tatMemRewardsRule/edit',
    GetTatRank: '/tatMemRewardsRank/getTatRank',
};

//机具管理and配置
const PosApi = {
    RecoveryCz: '/machines/t-machines/recoveryMachine',
    PosManageList:'/machines/t-machines/list',
    PosManagejijuList:'/machines/t-machines/detail',
    PosJiJuType:'/machines/t-machines/activeTypeSelect',
    PosYingJianType:'/machines/t-machines/hardwareSelect',
    PosExchangeType:'/machines/t-machines/exchangeTypeSelect',
    PosSourceArea:'/machines/t-machines/sourceAreaSelect',
    PosGatherList:'/machines/t-machines/collectMachines',
    PosCollectionType:'/machines/t-machines/collectTypeSelect',
    PosSuoShuType:'/machines/t-machines/organizationSelect',
    PosStatistics:'/machines/t-machines/statistics',
    PosImplementIssuedcz: '/machines/t-machines/issuedMachine',
    PosImplementIssuedczpl: '/machines/t-machines/issuedMachineBatch',
    PosImplementUpstatus: '/machines/ext/updateStatus',
    GetPosSnAll: '/machines/t-machines/getMachineNumber',
    GetPosSnAllStandby: '/machines/t-machines/getMachineNumberForStatus',
    ChnCode: '/machinesCommon/channelList',
    Status: '/machines/ext/machineStatusList',
    PostransferinfoList: '/machines/t-machines-transfer-dtl/list',
    PosrateList:'/machines/t-machines-type/list', // 机具配置
    PosrateEdit:'/machines/t-machines-type/edit',
    PosrateInsert:'/machines/t-machines-type/add',
    PosrateDel: '/machines/t-machines-type/delete',
    PosrateManageList:'/machines/t-machines-type-fee/list',
    PosrateManageEdit:'/machines/t-machines-type-fee/edit',
    PosrateManageInsert: '/machines/t-machines-type-fee/add',
    CodePlaterateManageList: '/ysb/bp-info/list',  //码牌费率配置
    CodePlaterateManageStatus: '/ysb/bp-info/udpStatus',
    CodePlaterateInfoList: '/ysb/replace-business-product/list', //码牌费率修改明细接口
    YsPosCodePlaterateManageList: '/ysb/big-bp-info/list',  //银盛大pos码牌费率配置
    YsPosCodePlaterateManageStatus: '/ysb/big-bp-info/udpStatus',
    YsPosCodePlaterateInfoList: '/ysb/big-replace-business-product/list', //银盛大pos码牌费率修改明细接口
    Inquire: '/machines/t-machines/queryRegisterChannel', // 查询上游通道
    Promotion: '/machines/t-machines/upHkToLy' // 升级燎原
}
// 新增商户费率配置
const Merchant = {
    RecoveryCz: '/machines/t-machines/recoveryMachine',
    PosManageList:'/merchantType/list',
    PosManagejijuList:'/machines/t-machines/detail',
    PosJiJuType:'/machines/t-machines/activeTypeSelect',
    PosYingJianType:'/machines/t-machines/hardwareSelect',
    PosExchangeType:'/machines/t-machines/exchangeTypeSelect',
    PosSourceArea:'/machines/t-machines/sourceAreaSelect',
    PosGatherList:'/machines/t-machines/collectMachines',
    PosCollectionType:'/machines/t-machines/collectTypeSelect',
    PosSuoShuType:'/machines/t-machines/organizationSelect',
    PosStatistics:'/machines/t-machines/statistics',
    PosImplementIssuedcz: '/machines/t-machines/issuedMachine',
    PosImplementIssuedczpl: '/machines/t-machines/issuedMachineBatch',
    PosImplementUpstatus: '/machines/ext/updateStatus',
    GetPosSnAll: '/machines/t-machines/getMachineNumber',
    GetPosSnAllStandby: '/machines/t-machines/getMachineNumberForStatus',
    ChnCode: '/machinesCommon/channelList',
    Status: '/machines/ext/machineStatusList',
    PostransferinfoList: '/machines/t-machines-transfer-dtl/list',
    PosrateList:'/merchantType/t-merchant-type-fee/list', // 机具配置
    PosrateEdit:'/merchantType/edit',
    PosrateInsert:'/merchantType/add',
    PosrateDel: '/merchantType/delete',
    PosrateManageList:'/merchantType/t-merchant-type-fee/list',
    PosrateManageEdit:'/merchantType/t-merchant-type-fee/edit',
    PosrateManageInsert: '/merchantType/t-merchant-type-fee/add',
    CodePlaterateManageList: '/ysb/bp-info/list',  //码牌费率配置
    CodePlaterateManageStatus: '/ysb/bp-info/udpStatus',
    CodePlaterateInfoList: '/ysb/replace-business-product/list', //码牌费率修改明细接口
    YsPosCodePlaterateManageList: '/ysb/big-bp-info/list',  //银盛大pos码牌费率配置
    YsPosCodePlaterateManageStatus: '/ysb/big-bp-info/udpStatus',

    YsPosCodePlaterateInfoList: '/ysb/big-replace-business-product/list', //银盛大pos码牌费率修改明细接口
}
//商城管理  &  商户管理
const ShopApi = {
    ShopManageList: '/goods/t-goods-info/list',
    ShopManageInsert: '/goods/t-goods-info/add',
    ShopManageEdit: '/goods/t-goods-info/edit',
    ShopManageDel: '/goods/t-goods-info/delete',
    ShopManageStatus: '/goods/t-goods-info/updateStatus',
    ShopmanageAddress: '/addressAdmin/list',
    // 新增查询父级接口
    seeFather: '/goods/t-goods-info/getPidList',
    AppPointsShopManageList: '/merchantstore/t-merchant-goods-info/list',
    AppPointsShopManageInsert: '/merchantstore/t-merchant-goods-info/add',
    AppPointsShopManageEdit: '/merchantstore/t-merchant-goods-info/edit',
    AppPointsShopManageDel: '/merchantstore/t-merchant-goods-info/delete',
    AppPointsShopManageStatus: '/merchantstore/t-merchant-goods-info/updateStatus',

    AppPointsOrderQueryList: '/merchantstore/t-merchant-goods-order-info/list', //商户订单查询相关接口
    AppPointsOrderQueryEdit: '/merchantstore/t-merchant-goods-order-info/edit',
    AppPointsOrderQueryShenHe: '/goods/order/checkOrder',

    OrderQueryList: '/goods/order/list', //订单查询相关接口
    OrderQueryEdit: '/goods/order/edit',
    OrderQueryShenHe: '/goods/order/checkOrder',
    OrderQueryCreate: '/goods/order/addManager',
    OrderQueryCreate3000: '/goods/order/createOrder3000',
    OrderQueryLb: '/goods/order/createOrderLb',
    ExpressTypes: '/storeOrderInfo/logistics/dict', //快递公司接口
    LogisticsInfoList: '/storeOrderInfo/query/details',

    ShopPaymentList: '/paytype/list',//支付方式相关接口
    ShopPaymentInsert: '/paytype/add',
    ShopPaymentEdit: '/paytype/edit',
    ShopPaymentDel: '/paytype/delete',
    ShopPaymentStatus: '/paytype/updateStatus',

    ShopCollectionList: '/proceedsaccount/list',//收款账号相关接口
    ShopCollectionInsert: '/proceedsaccount/add',
    ShopCollectionEdit: '/proceedsaccount/edit',
    ShopCollectionDel: '/proceedsaccount/delete',
    ShopCollectionStatus: '/proceedsaccount/updateStatus',

    TopStatus: '/goods/order/orderStatus',

    ShoppingList: '/goods/t-goods-info/list',

    GiftPackManageList: '/gift/list',//礼包配置
    GiftPackManageEdit: '/gift/edit',
    GiftPackManageInsert: '/gift/add',
    GiftPackManageDel: '/gift/delete',

    GiftPackageDetailsList: '/gift/t-agent-gift/list',//代理商礼包
    GetTargetAgentId: '/gift/t-agent-gift/searchUser',
    GiftPackageDetailsEdit: '/gift/t-agent-gift/send',

    GiftPackageInfoList: '/gift/t-agent-gift-dtl/list',//礼包明细

    GiftPackagePut: '/gift/t-agent-gift/putGift',
    gdPhoneLlist: '/gdphone/list',

}

// 网申卡管理相关接口
const OnlineApi = {
    OnlineApplicationCardResourcesList: '/bankCardResource/list',
    OnlineApplicationCardResourcesSync: '/bankCardResource/cardResource/getResource',

    OnlineApplicationCardManageList: '/cardOrder/t-bank-commission/list',
    OnlineApplicationCardManageUpdate: '/cardOrder/t-bank-commission/edit',
    OnlineApplicationCardManageInsert: '/cardOrder/t-bank-commission/edit',
    OnlineApplicationCardManageStatus: '/cardOrder/t-bank-commission/enable',
    OnlineApplicationCardManageJd: '/cardOrder/t-bank-commission/stateList',

    MerOnlineApplicationCardManageList: '/cardOrder/t-bank-commission/list',
    MerOnlineApplicationCardManageUpdate: '/cardOrder/t-bank-commission/edit',
    MerOnlineApplicationCardManageInsert: '/cardOrder/t-bank-commission/edit',
    MerOnlineApplicationCardManageStatus: '/cardOrder/t-bank-commission/enable',
    MerOnlineApplicationCardManageJd: '/cardOrder/t-bank-commission/stateList',

    OnlineCardResultList: '/bankCardResource/cardOrder/list',
    OnlineCardResultLook: '/cardOrder/dtl/list',
}

//  富有管理 相关API接口地址
const RichApi = {
    MerchantAccessList: '/fy/baseInfo/list',      //商户入网
    MerchantAccessUpdateFile: '/fy/baseInfo/uploadPic',
    MerchantAccessSh: '/fy/baseInfo/checkCommit',
};
//  富有管理 相关API接口地址
const PospApi = {
    PospApLiist: '/merInfo/list',       // 商户管理
    channelMerchant: '/merInfo/mer-acq-mer-info/list',  // 商户管理终端
    merTidInfoList: '/merInfo/mer-tid-info/list', // 终端管理
    merAcqTidCnvList: '/merInfo/mer-acq-tid-cnv/list', // 终端子页面
    editData: '/merInfo/updateById', // 父页面修改
    joinData: '/merInfo/jinjian', // 进件
    // 子通道
    loadList: '/pospMer/mer-info-acq-uid/list',
    deleteData: '/merInfo/mer-acq-mer-info/cancelMerchant',
    deleteDataNew: '/merInfo/mer-acq-mer-info/del',
    pushNewPush: '/merchantinfo/t-merchant-info/updateTMerchantInfo',
    pushNewButton: '/merchantinfo/t-merchant-info/updateMachines'

};
const YiSheng = {
    YiShengList: '/ysmerinfo/t-ys-mer-info/list',
    YishengJoin: '/ysmerinfo/t-ys-mer-info/addMerchant',
    YishengAudit: '/ysmerinfo/t-ys-mer-info/getSigning',
    YishengChildOne: '/ysmerinfo/t-ys-mer-info/detail',
    YishengChildTwo: '/ysmerinfo/t-ys-plus-info/detail',
    YishengChildThree: '/ysmerinfo/t-ys-acc-info/detail',
    YishengChildFour: '/ysmerinfo/t-ys-pic-info/list',
    YishengChildFive: '/ysmerinfo/t-ys-func-info/list',
    yishengText: '/ysmerinfo/t-ys-mer-info/updateStatus',
    yishengAdd: '/ysmerinfo/t-ys-lic-info/detail',
    // 这里是商户费率管理
    yishengMoney: '/memFee/t-mem-fee/detail',
    // 变更基础信息
    yishengBase: '/ysmerinfo/t-ys-mer-info/updateMerchantSys',
    yishengOpen: '/ysmerinfo/t-ys-mer-info/updateMerchantAcc',
    yishengMoney: '/ysmerinfo/t-ys-mer-info/updateMerchantFunc',
     // 新增
     yishengNew: '/ysmerinfo/t-ys-mer-info/getFuncInfo',
     toEdit: '/ysmerinfo/t-ys-mer-info/edit'
};
// 机构
const InstitutionList = {
    addList: '/tatinfo/add', // 添加机构
    stitutionList: '/tatinfo/list', // 机构管理列表
    editStitution: '/tatinfo/edit', // 修改机构
    disable: '/tatinfo/udpStatus', // 禁用启用
    // 新增机具的东西
    moneyList: '/xhls/config/list', // 鼓励金
    // 机构提现
    moneyWithAdd: '/dflhwithdrawapplytat/add',
    moneySearch: '/dflhwithdrawapplytat/list',
    // 机构提现审核
    moneyAgree: '/dflhwithdrawapplytat/checkApplyTure',
    moneyUnAgree: '/dflhwithdrawapplytat/checkApplyFalse',
    // 机构提现详情
    moneyDetail: '/tatinfo/detail'
}
// 活动页面
const activity = {
    activityList: '/activity/admin-activity/list', // 列表
    addList: '/activity/admin-activity/add', // 添加
    editList: '/activity/admin-activity/edit', // 修改
    deleteList: '/activity/admin-activity/delete', // 删除
    udpStatus: '/activity/admin-activity/udpStatus', // 改变状态
    editDaili: '/activity/tat-activity-mem/edit'
}
// 机构活动
const instituActivity = {
    activityList: '/activity/tat-activity/list',
    addActivity: '/activity/tat-activity/add',
    deleteList: '/activity/tat-activity/delete',
    detailList: '/activity/admin-activity/detail'
}
// 代理活动
const brokenActivity = {
    activityList: '/activity/tat-activity-mem/list'
}
const brokenActivityNew = {
    activityList: '/activity/tat-activity-mem-template/list'
}
// 欢迎页
const welcome = {
    welcomeData: '/tatacct/selectTempAcct'
} 
// 燎原
const prairies = {
    prairiesList: '/liaoyuan/ly-merc-register-template/list',
    addPrairies: '/liaoyuan/ly-merc-register-template/add',
    openAddprairies: '/liaoyuan/ly-merc-register-template/udpStatus',
    signList: '/liaoyuan/ly-merc-register-machines/list',
    signListThree: '/liaoyuan/ly-sn-device-fee/list',
    signListFour: '/liaoyuan/ly-operate-log/list',
    aqfbyhglList: '/pospinfo/tat-posp-mem-info/list',
    signLiuliang: '/liaoyuan/ly-merc-register-machines/liuliangfeiSet',
    editData: '/liaoyuan/ly-merc-register-machines/edit'
} 
export {
    YiSheng,
    PospApi,
    MallApi,
    UserApi,
    OrganApi,
    ChannelApi,
    ChannelRateApi,
    OrganNoteApi,
    SystemDicApi,
    OrganAuthApi,
    OrganRateApi,
    PowerUserApi,
    PowerRoleApi,
    PowerInfoApi,
    TransactionApi,
    FinanceApi,
    OrganCashApi,
    ChannelCashApi,
    ValueAddApi,
    StatisticsApi,
    SystemPushApi,
    OrganAppApi,
    MemberManApi,
    MemberLevelApi,
    MemberChannelRateApi,
    MemberLevelRateApi,
    APPApi,
    RongBaoApi,
    CardUnbindApi,
    MemApplyInfoApi,
    TatBankProfitApi,
    TatBankChnApi,
    SystemPropApi,
    BankSettingApi,
    MarketApi,
    TatMemRewardsApi,
    EmptyApi,

    PosApi,
    ShopApi,

    OnlineApi,

    RichApi,
    Merchant,
    InstitutionList,
    activity,
    instituActivity,
    brokenActivity,
    welcome,
    
    brokenActivityNew,
    prairies
};



// WEBPACK FOOTER //
// ./src/service/constant/UrlMapper.js